import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconInstagram = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="10"
            cy="10"
            r="10"
          />
          <g clipPath={`url(#&{svgId})`}>
            <path
              d="M10 4.26175C11.869 4.26175 12.0907 4.26875 12.8292 4.30258C14.7262 4.38892 15.6122 5.289 15.6986 7.172C15.7324 7.90992 15.7388 8.13158 15.7388 10.0006C15.7388 11.8702 15.7318 12.0912 15.6986 12.8292C15.6117 14.7104 14.7279 15.6122 12.8292 15.6986C12.0907 15.7324 11.8702 15.7394 10 15.7394C8.131 15.7394 7.90933 15.7324 7.17142 15.6986C5.26975 15.6117 4.38833 14.7075 4.302 12.8286C4.26817 12.0907 4.26117 11.8696 4.26117 10C4.26117 8.131 4.26875 7.90992 4.302 7.17142C4.38892 5.289 5.27267 4.38833 7.17142 4.302C7.90992 4.26875 8.131 4.26175 10 4.26175ZM10 3C8.09892 3 7.86092 3.00817 7.11425 3.042C4.57208 3.15867 3.15925 4.56917 3.04258 7.11367C3.00817 7.86092 3 8.09892 3 10C3 11.9011 3.00817 12.1397 3.042 12.8863C3.15867 15.4285 4.56917 16.8413 7.11367 16.958C7.86092 16.9918 8.09892 17 10 17C11.9011 17 12.1397 16.9918 12.8863 16.958C15.4262 16.8413 16.8425 15.4308 16.9574 12.8863C16.9918 12.1397 17 11.9011 17 10C17 8.09892 16.9918 7.86092 16.958 7.11425C16.8437 4.57442 15.4314 3.15925 12.8869 3.04258C12.1397 3.00817 11.9011 3 10 3V3ZM10 6.4055C8.01492 6.4055 6.4055 8.01492 6.4055 10C6.4055 11.9851 8.01492 13.5951 10 13.5951C11.9851 13.5951 13.5945 11.9857 13.5945 10C13.5945 8.01492 11.9851 6.4055 10 6.4055ZM10 12.3333C8.71142 12.3333 7.66667 11.2892 7.66667 10C7.66667 8.71142 8.71142 7.66667 10 7.66667C11.2886 7.66667 12.3333 8.71142 12.3333 10C12.3333 11.2892 11.2886 12.3333 10 12.3333ZM13.7368 5.42375C13.2725 5.42375 12.8962 5.8 12.8962 6.26375C12.8962 6.7275 13.2725 7.10375 13.7368 7.10375C14.2006 7.10375 14.5762 6.7275 14.5762 6.26375C14.5762 5.8 14.2006 5.42375 13.7368 5.42375Z"
              fill="url(#paint0_linear_2647_11023)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_2647_11023"
              x1="12.9167"
              y1="3"
              x2="7.97542"
              y2="16.1421"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#5E5CCB" />
              <stop
                offset="0.18214"
                stopColor="#8D40B7"
              />
              <stop
                offset="0.431696"
                stopColor="#DA2E7C"
              />
              <stop
                offset="0.753527"
                stopColor="#F15544"
              />
              <stop
                offset="1"
                stopColor="#FECA66"
              />
            </linearGradient>
            <clipPath id={svgId}>
              <rect
                width="14"
                height="14"
                transform="translate(3 3)"
              />
            </clipPath>
          </defs>
        </svg>
      </SvgIcon>
    );
  })
);
